import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import MenuPermissaoItem from '@/app-modulo/comuns/grupo-usuario/shared/components/menu-permissao/MenuPermissaoItem.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
// Componente referência ele mesmo, por isso precisa estar aqui
Vue.component(MenuPermissaoItem.name, MenuPermissaoItem)
